<template>
	<div id="panel_upcoming_events" class="panel upcoming_events theme-light">
		<div class="container">
			<div class="panel_header">
				<div class="row">
					<div class="col-12">
						<h2>Ближайшие события</h2>
					</div>
				</div>
				<!--<nuxt-link class="panel_control" to="#"></nuxt-link>-->
			</div>
			<div v-if="fetchedData" class="row">
				<div
					v-for="(event, index) in fetchedData.data"
					:key="event.title"
					class="col-12 col-md-6 col-lg-4 mb-4"
					:class="{'d-none d-md-block d-lg-none' : index === 3}"
				>
					<div class="upcoming-item">
						<div class="upcoming-item_top">
							<div class="date">
								<div class="date_day">
									<span>{{ event.event_date | moment("DD") }}</span>
								</div>
								<div class="date_properties">
									<b>{{ event.event_date | moment("MMMM") }}</b>
									<b>{{ event.event_date | moment("HH:mm") }}</b>
								</div>
							</div>
							<div v-if="event.type_titles" class="tag_string">
								<nuxt-link :to="$url.events({ query: { type:event.type } })">
									{{ event.type_titles.title_default }}
								</nuxt-link>
							</div>
							<nuxt-link
								:to="$url.event(event.slug, event.typology_slug)"
								class="title"
							>
								{{ event.title }}
							</nuxt-link>
						</div>
						<div class="upcoming-item_bottom">
							<nuxt-link
								:to="$url.event(event.slug, event.typology_slug)"
								class="more_link"
							>
								Детали и регистрация
							</nuxt-link>
						</div>
					</div>
				</div>
				<!-- Четвертый элемент d-lg-none -->
			</div>
			<div class="panel_footer">
				<div class="row">
					<div class="col-12">
						<!-- <a
							href="/navigator/events/"
							class="btn btn-primary"
						>Все ближайшие события</a> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '@/utils/moment';

export default {
	name: 'IssueUpcomingEventsPanel',
	data() {
		return {
			fetchedData: null,
		};
	},
	mounted() {
		this.$pagesApi.events({ pageSize: 3, order_by: 'asc', index_list: true })
			.then((response) => { this.fetchedData = response; });
	},
};
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/components/home/issue-upcoming-events-panel';
</style>
